var typography$1={bodyNormal:{fontFamily:{value:"'OpenSans'"},fontSize:{value:"16px"},lineHeight:{value:"20px"},fontWeight:{value:400}},bodyMedium:{fontFamily:{value:"'OpenSans'"},fontSize:{value:"14px"},lineHeight:{value:"20px"},fontWeight:{value:400}},bodySmall:{fontFamily:{value:"'OpenSans'"},fontSize:{value:"12px"},lineHeight:{value:"20px"},fontWeight:{value:400}},bodyCaption:{fontFamily:{value:"'OpenSans'"},fontSize:{value:"10px"},lineHeight:{value:"20px"},fontWeight:{value:400}},bodyButton:{fontFamily:{value:"'OpenSans'"},fontSize:{value:"14px"},lineHeight:{value:"20px"},fontWeight:{value:400}},headingSmall:{fontFamily:{value:"'Open Sans'"},fontSize:{value:"18px"},lineHeight:{value:"22px"},fontWeight:{value:700}},headingNormal:{fontFamily:{value:"'Open Sans'"},fontSize:{value:"24px"},lineHeight:{value:"28px"},fontWeight:{value:700}},headingBig:{fontFamily:{value:"'Open Sans'"},fontSize:{value:"28px"},lineHeight:{value:"32px"},fontWeight:{value:700}}};var tokens = {typography:typography$1};

var typography = {
    global: {
        family: "Open-Sans, Arial, sans-serif",
    },
    heading: {
        big: {
            fontSize: tokens.typography.headingBig.fontSize.value,
            lineHeight: tokens.typography.headingBig.lineHeight.value,
            fontWeight: tokens.typography.headingBig.fontWeight.value,
        },
        normal: {
            fontSize: tokens.typography.headingNormal.fontSize.value,
            lineHeight: tokens.typography.headingNormal.lineHeight.value,
            fontWeight: tokens.typography.headingNormal.fontWeight.value,
        },
        small: {
            fontSize: tokens.typography.headingSmall.fontSize.value,
            lineHeight: tokens.typography.headingSmall.lineHeight.value,
            fontWeight: tokens.typography.headingSmall.fontWeight.value,
        },
    },
    body: {
        normal: {
            fontSize: tokens.typography.bodyNormal.fontSize.value,
            lineHeight: tokens.typography.bodyNormal.lineHeight.value,
            fontWeight: tokens.typography.bodyNormal.fontWeight.value,
        },
        medium: {
            fontSize: tokens.typography.bodyMedium.fontSize.value,
            lineHeight: tokens.typography.bodyMedium.lineHeight.value,
            fontWeight: tokens.typography.bodyMedium.fontWeight.value,
        },
        small: {
            fontSize: tokens.typography.bodySmall.fontSize.value,
            lineHeight: tokens.typography.bodySmall.lineHeight.value,
            fontWeight: tokens.typography.bodySmall.fontWeight.value,
        },
        caption: {
            fontSize: tokens.typography.bodyCaption.fontSize.value,
            lineHeight: tokens.typography.bodyCaption.lineHeight.value,
            fontWeight: tokens.typography.bodyCaption.fontWeight.value,
        },
        button: {
            fontSize: tokens.typography.bodyButton.fontSize.value,
            lineHeight: tokens.typography.bodyButton.lineHeight.value,
            fontWeight: tokens.typography.bodyButton.fontWeight.value,
        },
    },
};

export { typography as t };
//# sourceMappingURL=typography-6b8aa0ed.js.map
